import React, { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import {
  extractDateFromStr,
  getLatestDateFromData,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import PdfZipItem from "../../components/PdfZipItem";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const ComprehensiveGuidelinePage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });
  const { getText } = useLanguageTranslation();
  const { data: comprehensiveGuideline = [], isLoading: offerWorksIsLoading } =
    useGetProtectedApiDataQuery({
      url: "comprehensive-guideline",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(comprehensiveGuideline);
  }, [comprehensiveGuideline]);

  if (offerWorksIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/comprehensive-guideline"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th> {getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड ")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {comprehensiveGuideline.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            <PdfZipItem
                              filePath={item?.field_download}
                              filesize={item?.filesize}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComprehensiveGuidelinePage;
